export default "__VITE_ASSET__CymntENk__"